import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DryRunAlert } from "../../mk8s/dryRunAlert";
import { DomainInput } from "./types/input";

interface Props {
  path: string;
  paths?: string[];
  onFix?: (value: string) => void;
}
export const FormDryRunAlert: React.FC<Props> = ({ path, paths, onFix }) => {
  const { watch } = useFormContext<DomainInput>();
  const dryRun = watch("dryRun.raw.value") || {};
  const dryRunNameOnly = watch("dryRun.nameOnly.value") || {};

  const finalDryRun = React.useMemo(() => {
    return dryRunNameOnly.status === 200 ? dryRun : dryRunNameOnly;
  }, [dryRun, dryRunNameOnly]);

  return (
    <div className="mt-2 mb-8">
      <DryRunAlert canShow={true} path={path} paths={paths} dryRunResponse={finalDryRun as any} onFix={onFix} />
    </div>
  );
};
